import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {ItemSetting} from "../../models/itemSetting.model";

export class PricePlanBundlePackageItemSelectCtrl implements IController {
  form: any;
  packageItem: ItemSetting;
  options: ItemSetting[];
  onChange: Function;

  public allPackageItems: ItemSetting[];
  public allIcons: string[];

  constructor(private pricePlanConstant) {
    this.allPackageItems = this.pricePlanConstant.packageItemsDefaultSettings;
    this.allIcons = _.flatMap(this.pricePlanConstant.packageItemsDefaultSettings, 'icon');
  }

  $onInit() {
    if (!this.options) {
      this.options = angular.copy(this.allPackageItems);
    }
  }


}

angular
  .module('bringoz.admin.pricePlan')
  .component('pricePlanBundlePackageItemSelect', {
    require: {
      form: '^form'
    },
    bindings: {
      packageItem: '<',
      onChange: '&'
    },
    template: require('./price-plan-bundle-package-item-select.html').default,
    controller: PricePlanBundlePackageItemSelectCtrl

  });
